<div class="row">
  <div class="col s12 m12">
    <h3 class="center">The Playlists</h3>
    <p class="center">
      Here you can create your own playlist, edit your already existing
      playlist, add songs, and show it to the world!
    </p>
  </div>
</div>

<div class="fixed-action-btn" *ngIf="isLoggedin">
  <a
    data-target="modal1"
    class="btn-floating btn-large modal-trigger waves-effect waves-light yellow lighten-1 "
    ><i class="material-icons grey-text text-darken-4">playlist_add</i></a
  >
</div>

<div class="row">
  <div class="col s12 center" *ngIf="loading; else notLoading">
    <div class="preloader-wrapper big active">
      <div class="spinner-layer spinner-yellow-only">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div>
        <div class="gap-patch">
          <div class="circle"></div>
        </div>
        <div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #notLoading>
    <div class="col s12 ">
      <div
        class="card-panel card white"
        style="border-left:10px solid #ffee58 "
      >
        <span class="black-text"
          >{{ playlists.length }} Collection of Playlists</span
        >
      </div>
    </div>
    <div class="col s12" *ngFor="let ply of playlists">
      <div class="card" style="margin-top: 2rem;">
        <div class="card-title">
          <h5 class="header">{{ ply.name }}</h5>
          <p
            class="grey-text"
            style="font-weight: 400; margin-top: -7px; font-size: 0.85rem;"
          >
            {{ ply.totalSongs }} {{ totalSongs == 1 ? "song" : "songs" }},
            {{ ply.totalDuration }} minutes · {{ ply.by }}
          </p>
          <p
            style="font-size: 1rem; margin: -5px 0; font-weight: 400; text-transform: capitalize;"
          >
            {{ ply.description }}
          </p>
        </div>
        <div class="card-content grey-text text-darken-4">
          <div class="row" *ngFor="let song of ply.songs">
            <div
              class="col s12"
              style="display: flex; align-items: center; justify-content: start;"
            >
              <i class="material-icons left">audiotrack</i>
              <h5 class="header" style="font-size: 1.2rem;">
                {{ song.title }}
                <p class="grey-text" style="font-size: 1rem;">
                  by {{ song.artist }} · {{ song.duration }}
                  {{ song.duration == 1 ? "minute" : "minutes" }}
                </p>
              </h5>
            </div>
          </div>
        </div>
        <div class="card-action">
          <button
            (click)="onDelete(ply)"
            class="btn waves-effect waves-red btn-flat red-text"
          >
            delete
          </button>
          <button
            (click)="editingForm(ply)"
            data-target="modal1"
            class="modal-trigger btn waves-effect waves-light btn-flat black-text"
          >
            edit
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>

<!-- Modal New Playlist -->
<div id="modal1" class="modal modal-fixed-footer">
  <div class="modal-content">
    <h5 style="margin-bottom: 1.6rem;">Create New Playlist</h5>
    <div class="row">
      <form class="col s12" [formGroup]="plyForm">
        <div class="row">
          <div class="input-field col s6">
            <input
              id="playlistname"
              type="text"
              class="validate"
              formControlName="name"
              placeholder="Playlist Name"
              required
            />
          </div>
          <div class="input-field col s6">
            <input
              id="by"
              type="text"
              class="validate"
              formControlName="by"
              placeholder="Your Name"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <input
              id="desc"
              type="text"
              class="validate"
              formControlName="description"
              placeholder="Description"
              required
            />
          </div>
        </div>
        <div class="row" formArrayName="songs">
          <div
            *ngFor="let play of playlistForm.controls; let i = index"
            [formGroupName]="i"
          >
            <div class="input-field col s12 m4">
              <input
                id="title{{ i }}"
                type="text"
                class="validate"
                formControlName="title"
                placeholder="Title"
                required
              />
            </div>
            <div class="input-field col s12 m3">
              <input
                id="artist{{ i }} "
                type="text"
                class="validate"
                formControlName="artist"
                placeholder="Artist"
                required
              />
            </div>
            <div class="input-field col s12 m3 with-span">
              <input
                id="duration{{ i }} "
                type="number"
                class="validate"
                formControlName="duration"
                placeholder="Duration"
                required
              /><span> minutes</span>
            </div>
            <div class="input-field col s12 m2 with-button">
              <a
                *ngIf="playlistForm.length > 1"
                (click)="deleteField(i)"
                class="btn-floating btn-small btn-flat waves-effect waves-light red form"
                ><i class="tiny material-icons">remove</i></a
              >
              <a
                *ngIf="i == playlistForm.length - 1"
                (click)="addField()"
                class="btn-floating btn-small btn-flat waves-effect waves-light indigo form"
                ><i class="tiny material-icons">add</i></a
              >
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <a
      class="modal-close waves-effect waves-red lighten-1 btn-flat"
      (click)="cancel()"
      >cancel</a
    >
    <button
      *ngIf="!editing"
      [disabled]="!plyForm.valid"
      class="modal-close waves-effect waves-yellow btn-flat"
      (click)="onSubmit()"
    >
      submit
    </button>
    <button
      *ngIf="editing"
      [disabled]="!plyForm.valid"
      class="modal-close waves-effect waves-yellow btn-flat"
      (click)="onEdit()"
    >
      submit
    </button>
  </div>
</div>
